'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        height: "32px",
        zIndex: 1,
        borderRadius: "3px !important",
        "& em": {
            color: variables.COLORS.TEXT_SECONDARY,
            WebkitFontSmoothing: "antialiased",
            "&::after": {
                content: "",
            },
        },
        "& ~i": {
            position: "absolute",
            right: "12px",
        },
        "&[aria-expanded=true]": {
            backgroundColor: variables.COLORS.GREYSCALE_0_05,
        },
        "& ~fieldset": {
            boxShadow: "none !important",
            border: "none !important",
            backgroundColor: "unset !important",
        },
        "&:hover": {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
        },
        "&:active": {
            backgroundColor: variables.COLORS.GREYSCALE_0_10,
        },
        "&:focus": {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
            borderRadius: "3px !important",
            border: `solid 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
            boxShadow: `inset 0px 0px 0px 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
        },
        "&$disabled": {
            opacity: "unset",
            color: variables.COLORS.GREYSCALE_0_30,
            "&:hover": {
                backgroundColor: variables.COLORS.GREYSCALE_0_0,
                borderColor: variables.COLORS.GREYSCALE_0_15,
            },
            "& ~i": {
                color: variables.COLORS.GREYSCALE_0_30,
            },
        },
    },
    selectMenu: {
        height: "14px",
    },
    outlined: {
        border: `solid 1px ${variables.COLORS.GREYSCALE_0_15}`,
    },
};

var MuiSelect = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiSelect = MuiSelect;
exports.light = light;
